import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "d-flex justify-space-between flex-md-row flex-column" },
      [
        _c(VTextField, {
          staticClass: "ma-5",
          attrs: {
            label: _vm.$vuetify.lang.t("$vuetify.base.startDate"),
            type: "date",
            clearable: "",
            rules: [_vm.rules.required],
          },
          model: {
            value: _vm.startDate,
            callback: function ($$v) {
              _vm.startDate = $$v
            },
            expression: "startDate",
          },
        }),
        _c(VTextField, {
          staticClass: "ma-5",
          attrs: {
            label: _vm.$vuetify.lang.t("$vuetify.base.endDate"),
            type: "date",
            clearable: "",
            rules: [_vm.rules.dateRange(_vm.startDate, _vm.endDate)],
          },
          model: {
            value: _vm.endDate,
            callback: function ($$v) {
              _vm.endDate = $$v
            },
            expression: "endDate",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      [
        _c(
          VBtn,
          {
            on: {
              click: function ($event) {
                return _vm.submit()
              },
            },
          },
          [_vm._v("Submit")]
        ),
      ],
      1
    ),
    _c("div", [
      _vm._v(" " + _vm._s(_vm.inputs) + " " + _vm._s(_vm.outputs) + " "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }